export const siteConfig = {
  name: "Okuant",
  tagline: "Independent experts in real estate asset investments",
  taglineEs: "Expertos independientes en inversiones de activos inmobiliarios",
  email: "inversion@okuant.com",
  phone: "91 000 17 77",
  address: "Calle Claudio Coello 33, 1º A",
  city: "28001 Madrid",
};

export const heroContent = {
  en: {
    title: "Investment Servicers",
    subtitle: "Independent experts in real estate asset investments",
    subtext: "Technology and Experience at the investor's service",
  },
  es: {
    title: "Investment Servicers",
    subtitle: "Expertos independientes en inversiones de activos inmobiliarios",
    subtext: "Tecnología y Experiencia al servicio del inversor",
  },
};

export const technologySection = {
  en: {
    title: "TECHNOLOGY",
    description: "We have our own BUSINESS INTELLIGENCE tool that manages more than 2 million real estate assets in each operation.",
  },
  es: {
    title: "TECNOLOGÍA",
    description: "Contamos con nuestra propia herramienta de BUSINESS INTELLIGENCE que mueve más de 2 millones de activos inmobiliarios en cada operación.",
  },
};

export const experienceSection = {
  en: {
    title: "EXPERIENCE",
    description: "Management and marketing of real estate assets ensuring greater profitability.",
  },
  es: {
    title: "EXPERIENCIA",
    description: "Gestión y Comercialización de activos inmobiliarios asegurando una mayor rentabilidad.",
  },
};

export const servicesPage = {
  en: {
    title: "Services",
    subtitle: "We cover every phase of the real estate asset investment process",
    investment: {
      title: "Investment",
      description: "We combine technology, know-how and experience to read and analyse the evolution of the market in real time.",
    },
    management: {
      title: "Management",
      description: "We are experts in the management of bank-owned assets with any legal status or situation.",
    },
  },
  es: {
    title: "Servicios",
    subtitle: "Cubrimos todo el proceso de inversión en activos inmobiliarios",
    investment: {
      title: "Inversión",
      description: "Unimos tecnología, know-how y experiencia para leer y analizar la evolución del mercado en tiempo real.",
    },
    management: {
      title: "Gestión",
      description: "Somos expertos en la gestión de activos bancarios en cualquiera de sus estados o situaciones legales.",
    },
  },
};

export const investmentPage = {
  en: {
    title: "Investment",
    intro: "We combine technology, know-how and experience to read and analyse the evolution of the market in real time.",
    points: [
      "We are able to automatically detect and value the best investment pools nationwide.",
      "We connect our investor clients' demand with the entities' supply.",
      "We negotiate with financial institutions and manage the entire purchase process.",
      "Our selection methodology guarantees the revaluation of the real estate asset and the profitability of the investment.",
      "We accompany our clients throughout the complete investment cycle, from opportunity identification to investment execution.",
    ],
    cta: "More information",
  },
  es: {
    title: "Inversión",
    intro: "Unimos tecnología, know-how y experiencia para leer y analizar la evolución del mercado en tiempo real.",
    points: [
      "Somos capaces de detectar y valorar de manera automatizada las mejores bolsas de inversión en territorio nacional.",
      "Conectamos la demanda de nuestros clientes inversores con la oferta de las entidades.",
      "Negociamos con las entidades financieras y gestionamos todo el proceso de compra.",
      "Nuestra metodología de selección garantiza la revalorización del activo inmobiliario y la rentabilidad de la inversión.",
      "Acompañamos a nuestros clientes en el ciclo completo de la inversión, desde la identificación de la oportunidad hasta la ejecución de la inversión.",
    ],
    cta: "Más información",
  },
};

export const managementPage = {
  en: {
    title: "Management",
    intro: "We are experts in the management of bank-owned assets with any legal status or situation, including assets in illegal occupation.",
    points: [
      "In case of asset in illegal occupation, we negotiate with the occupants and offer advice and solutions beneficial to all parties, thus accelerating the market exit of the assets.",
      "We handle direct marketing of assets, both sale and rental.",
      "We do comprehensive management and Property Management services.",
      "Direct reporting to investors through our technology platform.",
    ],
    cta: "More information",
  },
  es: {
    title: "Gestión",
    intro: "Somos expertos en la gestión de activos bancarios en cualquiera de sus estados o situaciones legales, incluidos los activos en situación de ocupación ilegal.",
    points: [
      "En caso de activo en situación de ocupación ilegal, entablamos negociaciones con los ocupantes y ofrecemos asesoramiento y soluciones beneficiosas para todas las partes, acelerando así la salida al mercado de los activos.",
      "Nos encargamos de la comercialización directa de los activos, tanto venta como alquiler.",
      "Hacemos gestión integral y servicios de Property Management.",
      "Reporting directo a inversores a través de nuestra plataforma tecnológica.",
    ],
    cta: "Más información",
  },
};

export const corporatePage = {
  en: {
    title: "Corporate",
    subtitle: "We are Okuant",
    description: "Technology, market knowledge and experience at the investor's service",
    sections: {
      company: { title: "Company", description: "Our mission and vision" },
      technology: { title: "Technology", description: "Our proprietary tools" },
    },
  },
  es: {
    title: "Corporativo",
    subtitle: "Somos Okuant",
    description: "Tecnología, conocimiento de mercado y experiencia al servicio del inversor",
    sections: {
      company: { title: "Compañía", description: "Nuestra misión y visión" },
      technology: { title: "Tecnología", description: "Nuestras herramientas propias" },
    },
  },
};

export const companyPage = {
  en: {
    title: "Company",
    intro: "We are an independent company specialized in the acquisition and comprehensive management of real estate portfolios from financial institutions and developers.",
    paragraphs: [
      "Our objective is to generate profitability for our clients by taking advantage of investment opportunities that may arise in the Spanish real estate market. To this end, at OKUANT we work in all phases of the process, managing our clients' investments and guaranteeing the security and success of the operations.",
      "Our technology, which allows us to detect and value investment opportunities in real time, combined with our market positioning and greater negotiating power, make OKUANT the best option when it comes to tackling investment and disinvestment procedures with guarantees.",
    ],
    cta: "More information",
  },
  es: {
    title: "Compañía",
    intro: "Somos una compañía independiente especializada en la adquisición y gestión integral de carteras inmobiliarias procedentes de entidades financieras y promotores.",
    paragraphs: [
      "Nuestro objetivo es generar rentabilidad para nuestros clientes mediante el aprovechamiento de las oportunidades de inversión que pudieran surgir en el mercado inmobiliario español. Para ello, en OKUANT trabajamos en todas las fases del proceso, gestionando las inversiones de nuestros clientes y garantizando la seguridad y éxito de las operaciones.",
      "Nuestra tecnología, que nos permite detectar y valorar oportunidades de inversión en tiempo real, unida a nuestro posicionamiento en el mercado y mayor poder de negociación, convierten a OKUANT en la mejor opción a la hora de afrontar con garantías procedimientos de inversión y desinversión.",
    ],
    cta: "Más información",
  },
};

export const technologyPage = {
  en: {
    title: "Technology",
    intro: "At OKUANT we have a Database with exhaustive information on the Spanish real estate market, from both banks and individuals, and we have developed our own technology that allows us to know the market value of each property in real time, as well as analyse the market trend in each area. Our expert team of analysts verifies the quality of these valuations by applying market correctors and identifying possible \"hidden defects\", thus obtaining the optimal price and the best profitability conditions.",
    cta: "More information",
  },
  es: {
    title: "Tecnología",
    intro: "En OKUANT contamos con una Base de Datos con información exhaustiva del mercado inmobiliario español, tanto de bancos como de particulares, y hemos desarrollado una tecnología propia que nos permite saber el valor de mercado de cada inmueble en tiempo real, así como analizar la tendencia del mercado en cada zona. Nuestro equipo experto de analistas verifica la calidad de estas valoraciones aplicando correctores de mercado e identificando posibles «vicios ocultos», obteniendo así el precio óptimo y las mejores condiciones de rentabilidad.",
    cta: "Más información",
  },
};

export const teamPage = {
  en: {
    title: "Team",
    intro: "A team with more than 10 years of experience in banking, mortgages, debt and Real Estate.",
    members: [
      {
        name: "Álvaro García de Castro",
        role: "CEO",
        description: "Founding partner and CEO of Okuant. Specialist in the management of opportunistic residential portfolios for investors. Dedicated most of his career to the Real Estate market, in the areas of commercial and mortgage.",
      },
      {
        name: "Aurelio García",
        role: "Head of NPLs",
        description: "Leads strategic initiatives in the NPL sector, bringing expertise in distressed asset management and financial restructuring. Oversees portfolio acquisition, risk assessment, and recovery strategies.",
      },
      {
        name: "Jordi Serena",
        role: "Director Investor Relations",
        description: "Responsible for Investor Relations at Okuant. Previously spent 5 years working at Alantra and, prior to that, at PwC.",
      },
    ],
  },
  es: {
    title: "Equipo",
    intro: "Un equipo con más de 10 años de experiencia en banca, hipotecas, deuda y Real Estate.",
    members: [
      {
        name: "Álvaro García de Castro",
        role: "CEO",
        description: "Socio fundador y CEO de Okuant. Especialista en la gestión de carteras residenciales oportunistas para inversores. Ha dedicado la mayor parte de su carrera al mercado inmobiliario, en las áreas comercial e hipotecaria.",
      },
      {
        name: "Aurelio García",
        role: "Head of NPLs",
        description: "Lidera las iniciativas estratégicas en el sector de NPLs, aportando experiencia en gestión de activos distressed y reestructuración financiera. Supervisa la adquisición de carteras, evaluación de riesgos y estrategias de recuperación.",
      },
      {
        name: "Jordi Serena",
        role: "Director Investor Relations",
        description: "Responsable de Relaciones con Inversores en Okuant. Previamente trabajó 5 años en Alantra y, anteriormente, en PwC.",
      },
    ],
  },
};

export const contactPage = {
  en: {
    title: "Contact",
    infoTitle: "Information",
    formTitle: "CONTACT",
    labels: {
      email: "EMAIL",
      phone: "PHONE",
      location: "LOCATION",
      name: "Name",
      emailField: "Email",
      subject: "Subject",
      message: "Message",
      submit: "Send",
      privacy: "I accept the Privacy Policy.",
    },
  },
  es: {
    title: "Contacto",
    infoTitle: "Información",
    formTitle: "CONTACTO",
    labels: {
      email: "EMAIL",
      phone: "TELÉFONO",
      location: "LOCALIZACIÓN",
      name: "Nombre",
      emailField: "Email",
      subject: "Asunto",
      message: "Mensaje",
      submit: "Enviar",
      privacy: "Acepto la Política de Privacidad.",
    },
  },
};

export const navigation = {
  en: {
    home: "Home",
    technologyIMT: "Technology IMT",
    services: "Services",
    investment: "Investment",
    management: "Management",
    corporate: "Corporate",
    company: "Company",
    technology: "Technology",
    contact: "Contact",
  },
  es: {
    home: "Home",
    technologyIMT: "Tecnología IMT",
    services: "Servicios",
    investment: "Inversión",
    management: "Gestión",
    corporate: "Corporativo",
    company: "Compañía",
    technology: "Tecnología",
    contact: "Contacto",
  },
};

export const footer = {
  en: {
    legal: "Legal Notice",
    privacy: "Privacy Policy",
    cookies: "Cookies Policy",
    ethics: "Ethics Channel",
    security: "Security Policy",
    rights: "All rights reserved.",
  },
  es: {
    legal: "Aviso Legal",
    privacy: "Política de Privacidad",
    cookies: "Política de Cookies",
    ethics: "Canal Ético",
    security: "Política de Seguridad",
    rights: "Todos los derechos reservados.",
  },
};

export const cookieBanner = {
  en: {
    title: "This website uses cookies:",
    description: "The cookies on this website are used to personalize content and ads, offer social network functions and analyze traffic. In addition, we share information about your use of the website with our social media, advertising and web analytics partners, who may combine it with other information that you have provided to them or that they have collected from your use of their services.",
    configure: "Configuration",
    reject: "Reject",
    accept: "Accept",
    cookiesPolicy: "Cookies Policy",
  },
  es: {
    title: "Esta página web usa cookies:",
    description: "Las cookies de este sitio web se usan para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar el tráfico. Además, compartimos información sobre el uso que haga del sitio web con nuestros partners de redes sociales, publicidad y análisis web, quienes pueden combinarla con otra información que les haya proporcionado o que hayan recopilado a partir del uso que haya hecho de sus servicios.",
    configure: "Configuración",
    reject: "Rechazar",
    accept: "Permitir",
    cookiesPolicy: "Política de cookies",
  },
};
